import { useEffect, useRef } from "react";
const Init = (fn) => {
    const bHadInit = useRef(false);

    useEffect(() => {
        if (!bHadInit.current) {
            bHadInit.current = true;
            if (fn) { fn(); }
        }
    });

    return null;
};
export default Init;